import { _ } from '@icc/shared/helpers'

export const mountingLengths = [
    _("ROLLER_SHUTTER_LEGACY|Halter A (55 - 73 mm)"),
    _("ROLLER_SHUTTER_LEGACY|Halter B (73 - 103 mm)"),
    _("ROLLER_SHUTTER_LEGACY|Halter C (103 - 155 mm)")
]
export const crankLengths = [
    _("ROLLER_SHUTTER_LEGACY|min 50 cm długości"),
    _("ROLLER_SHUTTER_LEGACY|1/2 wysokości żaluzji"),
    _("ROLLER_SHUTTER_LEGACY|3/4 wysokości żaluzji")
]
